// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1wITv","content":"ManualTimeModal_content__3yKBR"};